import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=60affa96&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60affa96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60affa96')) {
      api.createRecord('60affa96', component.options)
    } else {
      api.reload('60affa96', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=60affa96&scoped=true&", function () {
      api.rerender('60affa96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N1MH9vbiKSII/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports